import { render, staticRenderFns } from "./CommentsDisplay.vue?vue&type=template&id=168ea7be&"
import script from "./CommentsDisplay.vue?vue&type=script&lang=js&"
export * from "./CommentsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168ea7be')) {
      api.createRecord('168ea7be', component.options)
    } else {
      api.reload('168ea7be', component.options)
    }
    module.hot.accept("./CommentsDisplay.vue?vue&type=template&id=168ea7be&", function () {
      api.rerender('168ea7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/comments/CommentsDisplay.vue"
export default component.exports